// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"776":"a705cf74","808":"f15af1ef","884":"d6745d5d"}[chunkId] + ".chunk.css";
};